import {
  EngagementCommercialProductReference,
  ProductReferenceDto,
} from '@epicuro-next/data/engagement/engagement-models';
import {
  DeliveryInfo,
  ProductReference,
} from '@epicuro-next/models/engagement';

export function mapCommercialProductReferencesToEngagement(
  productReferences?: ProductReference[],
) {
  if (!productReferences) return productReferences;

  return productReferences.reduce((collection, reference) => {
    if (reference?.deliveryInfo) {
      const transformDeliveryInfo = mapProductReferenceDeliveryInfo(
        reference.deliveryInfo as DeliveryInfo[],
      );

      collection.push({ ...reference, deliveryInfo: transformDeliveryInfo });
    } else collection.push(reference as ProductReferenceDto);

    return collection;
  }, [] as EngagementCommercialProductReference[]);
}

function mapProductReferenceDeliveryInfo(deliveryInfo: DeliveryInfo[]) {
  return deliveryInfo.map((info) => {
    const { quantity, deliveryDate, displayDateFrom, ...payload } = info;

    return {
      ...payload,
      quantity,
      deliveryDate,
    };
  });
}
